export default __webpack_public_path__ + "img/47ff6675ec7e070d9d92ac62952d99f7.svg";